jQuery( document ).ready( function( $ ) {
    $(".accordion div > dd").hide();
    $(".accordion div > dt > a").click(function() {
        return $(this).find("span").hasClass("u-icon-chevron-right") ? ($(this).parent().parent().addClass('open'), $(this).parent().next().slideDown().addClass('open'),
        $(this).find("span").removeClass("u-icon-chevron-right").addClass("u-icon-chevron-down")) : ($(this).parent().parent().removeClass('open'), $(this).parent().next().slideUp().removeClass('open'),
        $(this).find("span").removeClass("u-icon-chevron-down").addClass("u-icon-chevron-right")),
        !1
    });
    
$('.location-tab-trigger').on('click', function(e) {
        e.preventDefault();
    var this_location_tab = $(this).data('tab-location');
    $('.store-locations-tab-content').hide();
    $('.location-tab-trigger').removeClass('active');
    $(this).addClass('active');
    $('#location_' + this_location_tab).fadeIn( 200, function() {
     $('#location_' + this_location_tab).addClass('active');
    });
    //alert(this_location_tab);
});
 $('.back-to-top-trigger').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: '0px'}, 300);
 });
    
  $('.jump-trigger').on('click', function(e) {
    e.preventDefault();
    var objectSelect = $(this).attr('href');
    var objectPosition = $(objectSelect).offset().top - 220;
    $('html, body').animate({scrollTop: objectPosition}, 300);
 });
    
    /**
     * Init emergence library
     */ 
    /*
    emergence.init({
      reset: false,
      elemCusion: .99,
    });
    */
    /**
     * Init Fit Frame js
     */
    /*
    function fitFrameInit(){
        $('.main-content').fitFrame();
    }
    //fitFrameInit();
    */
    
    /**
     * Add class to navbar-toggler when clicked
     
    $('.navbar-toggler').click(function() {
        $(this).toggleClass('open');
    });
    */
    /**
     * Set cookie for site notification dismissal
     */
    /*
    if ($.cookie('site_note_close') != 'true') {
      $('.site-notification').removeClass('d-none');

      $('.site-note-close').click(function() {
        $.cookie('site_note_close', 'true', { expires: 10, path: '/' }); 
      });
    } else if ($.cookie('site_note_close') === 'true') {        
    }   
  */
  
    /**
     * Default Slick Slider Example
     */
    /*
    $('.slick-slideshow').slick({
      dots: true,
    });
*/

    /**
     * Smooth Scroll Hashed Links
     * This will scroll to link on same page
     * Or will smoothly scroll to a hashed section on another page after click
     */
/*
    $(function() {
      // your current click function
      // select all links with hashes, remove if don't link to anything (:not)
      // this is for same page hashed links
      $('a[href*=\\#]:not([href=\\#])').on('click', function() {
          //if (!$(this).parents('ul').hasClass('nav-tabs')) {
              var target = $(this.hash);
              // if target.length is 0, set target equal to the name attribuite with hash as value
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // smooth scroll to the target id
              if (target.length) {
                  $('html,body').animate({
                      scrollTop: target.offset().top
                  }, 1000);
                  return false;
              }
          //}
      });

      // check if the window location (URL) has a hash in it
      // smoothly scroll to that location
      if(window.location.hash) {
          var target = $(window.location.hash);
          // if target.length is 0, set target equal to the name attribuite with hash as value
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          // smooth scroll to the target id
          $('html, body').delay(1000).animate({
            scrollTop: $(target).offset().top + 'px'
          }, 1000);
          return false;
      }

    });
    */
/*

$('#fij-carousel ul').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 8000
});
*/
/*
$('#featured-product-carousel').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: false,
        autoplay: true,
        autoplaySpeed: 8000,
        adaptiveHeight:true,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
*/
 
$('.sv-owl-carousel').owlCarousel({
loop:true,
margin:0,
nav:true,
items:1
});
    
    $('.faq-item a.faq-open-close').on('click', function(e) {
        e.preventDefault();
        var this_faq_item = $(this).parent().parent().parent().parent().parent();
         if(this_faq_item.hasClass('active')){
            this_faq_item.find('.faq-item-content').slideUp( 200, function() {
            this_faq_item.removeClass('active');
            });
           } else {
            this_faq_item.find('.faq-item-content').slideDown( 200, function() {
            this_faq_item.addClass('active');
            });
           }
    });
    $('.faq-item span.faq-icon').on('click', function(e) {
        e.preventDefault();
        var this_faq_item = $(this).parent().parent().parent().parent();
         if(this_faq_item.hasClass('active')){
            this_faq_item.find('.faq-item-content').slideUp( 200, function() {
            this_faq_item.removeClass('active');
            });
           } else {
            this_faq_item.find('.faq-item-content').slideDown( 200, function() {
            this_faq_item.addClass('active');
            });
           }
    });
    
     $('select.taxonomy-select').on('change', function() {
        var this_value = $(this).val();
        //alert(this_value);
        $('.faq-list-wrapper').hide();
        $('.taxonomy-list-block a.taxonomy-list-item-link').removeClass('active');
        $('.taxonomy-list-item-link-' + this_value).addClass('active');
            
        $('#' + this_value).fadeIn( 300, function() {});
        });
    
    
if($('body').hasClass('page-template-template-faqs-page')){
    $('.faq-list-wrapper').hide();
    $('#showall').show();
    //$('#showall').delay(1000).fadeIn( 500, function() {});
    $('.taxonomy-list-block a.taxonomy-list-item-link').stop().on('click', function(e) {
        e.preventDefault();
        var this_item = $(this).parent().data('taxonomy');
        //alert(this_item);
        $('.faq-list-wrapper').hide();
        $('.taxonomy-list-block a.taxonomy-list-item-link').removeClass('active');
        $(this).addClass('active');
         $('#' + this_item).fadeIn( 300, function() {});
    });
}
    
});


